// Material-UI theme
// Check out everything that can be customised here:
// https://github.com/callemall/material-ui/blob/master/src/styles/getMuiTheme.js

import {
  grey100, grey300, grey400, grey500,
  white, darkBlack, fullBlack,
} from 'material-ui/styles/colors';
import spacing from 'material-ui/styles/spacing';
import Color from 'color';
import {tntBlue, tntAccent} from './tntColors';

export default {
  spacing: spacing,
  fontFamily: '"Lato", Helvetica, Arial, sans-serif',
  palette: {
    primary1Color: tntBlue,
    primary2Color: Color(tntBlue).darken(0.3).hex(),
    primary3Color: grey400,
    accent1Color: tntAccent,
    accent2Color: grey100,
    accent3Color: grey500,
    textColor: darkBlack,
    alternateTextColor: white,
    canvasColor: white,
    borderColor: grey300,
    disabledColor: grey400,
    pickerHeaderColor: tntBlue,
    clockCircleColor: Color(darkBlack).fade(0.07).string(),
    shadowColor: fullBlack,
  },
  card: {
    fontWeight: 700,
  },
};



// WEBPACK FOOTER //
// ./src/theme/tntMuiTheme.js